<template>
  <div class="empty-panel-ctnr">
    <img class="noDataImg" src="@/images/common/empty.png" alt />
    <div class="noDataTitle">暂无数据</div>
    <div class="noDataText">点击查询重新搜索</div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.empty-panel-ctnr {
  min-height: calc(100vh - 260px);
  margin: 0 auto;
  width: 1200px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;

  .noDataImg {
    width: 298px;
    height: 268px;
    margin-top: 86px;
  }

  .noDataTitle {
    font-size: 14px;
    color: #5b5b5b;
    margin-top: 20px;
  }

  .noDataText {
    margin-top: 6px;
    font-size: 12px;
    color: #8b8b8b;
    padding-bottom: 74px;
  }
}
</style>
